import { SavedSearch, SavedSearchDateRange, SavedSearchFilter } from '@creditsights/api-ui-web';
import { DataItemFormatter } from '@creditsights/styleguide-web';
import classNames from 'classnames/bind';
import React, { ReactElement } from 'react';
import { NoDataDash } from '../../../../../components/formatters';
import { getDateRangeDisplayValue } from './FiltersRenderer.logic';
import FormattedFilter from './FormattedFilter';
import styles from './FiltersRenderer.module.scss';

const cx = classNames.bind(styles);

const renderDateRange = (dateRange?: SavedSearchDateRange | null): JSX.Element | null => {
  const displayValue = getDateRangeDisplayValue(dateRange);

  if (!displayValue) {
    return null;
  }

  return (
    <div className={cx('filter')} data-testid="date-range-filter">
      {displayValue}
    </div>
  );
};

const FiltersRenderer: DataItemFormatter<SavedSearchFilter[], ReactElement, void, SavedSearch> = ({
  value: savedSearchFilters,
  item: { dateRange },
}) => {
  const showNoDataDash =
    !savedSearchFilters?.length && !dateRange?.startDate && !dateRange?.endDate && !dateRange?.relativeRange;

  return (
    <div className={cx('body')}>
      {showNoDataDash && <NoDataDash />}
      {renderDateRange(dateRange)}
      {savedSearchFilters.map((filter) => (
        <FormattedFilter filter={filter} key={filter.filterType} />
      ))}
    </div>
  );
};

export default FiltersRenderer;
